import { styled } from '@mui/material/styles';
import isPropValid from '@emotion/is-prop-valid';

export const VideoSilhouetteContainer = styled('div')`
  position: relative;
  top: 0;
  width: 100%;
  height: 100vh;
  pointer-events: none;
`;

interface MaskProps {
  order?: number;
}
export const VideoMaskContainer = styled('div', {
  shouldForwardProp: isPropValid,
})<MaskProps>`
  position: fixed;
  left: 0;
  top: 0;
  overflow: hidden;
  height: 100%;
  width: 100%;
  z-index: ${(props) => (props.order ? props.order : 'initial')};
  pointer-events: none;
`;

export const ImageForMask = styled('img')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  opacity: 1;
  z-index: 1;
  object-fit: cover;
`;
